import { kratosIntegration } from '@myme/utils';
import { POSTResetPasswordReqBody } from '../../reset-password/useResetPasswordForm';
import { KratosInitFlow } from '../../types';

export const handleResetPassword = async (flow: KratosInitFlow, data: POSTResetPasswordReqBody) => {
  const reqBody = {
    csrf_token: flow.csfrToken,
    email: data.email,
    method: 'link'
  };

  await kratosIntegration.request.submitSelfServiceRecoveryFlow(flow.flowId, undefined, reqBody);
};
